import Vue from 'vue';
import axios from 'axios';
import { API_URL } from '@/config';

// การตั้งค่าการแสดงผลของทั้งระบบ (แอดมินตั้งในหน้าการตั้งค่า ทุกคนใช้ร่วมกัน)
// โหลดจาก backend แล้วเก็บสำเนาไว้ในเบราว์เซอร์ เพื่อให้เปิดหน้าครั้งต่อไปไม่กะพริบ
const CACHE_KEY = 'dmeeting-settings-cache';

export const SLOT_LABELS = [
  { key: 'morning', label: 'เช้า', time: '05:00–10:59' },
  { key: 'noon', label: 'เที่ยง', time: '11:00–12:59' },
  { key: 'afternoon', label: 'บ่าย', time: '13:00–16:59' },
  { key: 'evening', label: 'เย็น', time: '17:00–20:59' },
  { key: 'night', label: 'กลางคืน', time: '21:00–04:59' },
  { key: 'friday', label: 'บ่ายวันศุกร์', time: 'ศุกร์ 12:00–20:59' },
];

// ต้องตรงกับ DEFAULT_SETTINGS ใน appSettings.js ฝั่ง backend
export const DEFAULT_SETTINGS = {
  greeting: {
    enabled: true,
    particle: '',
    slots: {
      morning: { hello: 'อรุณสวัสดิ์', extra: '' },
      noon: { hello: 'สวัสดีตอนเที่ยง', extra: 'อย่าลืมทานข้าวนะ' },
      afternoon: { hello: 'สวัสดีตอนบ่าย', extra: '' },
      evening: { hello: 'สวัสดีตอนเย็น', extra: 'วันนี้เหนื่อยไหม' },
      night: { hello: 'ดึกแล้ว', extra: 'พักผ่อนบ้างนะ' },
      friday: { hello: 'สุขสันต์วันศุกร์', extra: '' },
    },
  },
  calendarView: 'month',
  animations: true,
};

export function cloneSettings(s) {
  return JSON.parse(JSON.stringify(s));
}

function readCache() {
  try {
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    return cached && cached.greeting && cached.greeting.slots ? cached : cloneSettings(DEFAULT_SETTINGS);
  } catch (e) {
    return cloneSettings(DEFAULT_SETTINGS);
  }
}

export const settings = Vue.observable(readCache());

function apply(next) {
  Object.keys(next).forEach(k => Vue.set(settings, k, next[k]));
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(next));
  } catch (e) {
    // เก็บสำเนาไม่ได้ก็ใช้ได้เฉพาะรอบนี้
  }
  applyMotionClass();
}

let loading = null;

// โหลดจาก backend ครั้งเดียวต่อการเปิดเว็บ (force = โหลดใหม่)
export function ensureSettings(force) {
  if (!loading || force) {
    loading = axios.get(`${API_URL}/settings`)
      .then(res => { if (res.data && res.data.result) apply(res.data.result); })
      .catch(() => { /* โหลดไม่ได้ ใช้ค่าล่าสุดที่มี */ });
  }
  return loading;
}

// แอดมินบันทึก: backend ตรวจค่าแล้วส่งค่าที่บันทึกจริงกลับมา
export async function saveSettings(next) {
  const res = await axios.put(`${API_URL}/settings`, next);
  apply(res.data.result);
  return res.data.result;
}

// เครื่องที่ตั้งค่า "ลดการเคลื่อนไหว" ไว้ ปิดแอนิเมชันให้เสมอ (ไม่ขึ้นกับการตั้งค่าของระบบ)
export function prefersReducedMotion() {
  return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}

export function motionEnabled() {
  return settings.animations && !prefersReducedMotion();
}

// กระดาษสีโปรย: ตอนนี้ใช้แค่ในโหมดฉาย QR ที่ปิดไว้ (ไม่มีให้ตั้งค่าแล้ว) ตามแอนิเมชัน
export function confettiEnabled() {
  return motionEnabled();
}

// ใส่ class no-motion ที่ <html> ให้ CSS ปิดแอนิเมชันทั้งระบบ
export function applyMotionClass() {
  document.documentElement.classList.toggle('no-motion', !motionEnabled());
}
